import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login/Login';
import Register from './components/Register/Register';
import OrientedSearch from './components/OrientedSearch/Orientedsearch';
import Entities from './components/Entities/entities';
import Contacts from './components/Contacts/contacts';
import DetailedEntities from './components/DetailedEntities/detailedentities';
import CreateEntity from './components/createEntity/createentity';
import UserSettings from './components/UserSettings/usersettings';
import ListOfEntities from './components/listOfEntities/listOfEntities';
import CreateDetailedEntities from './components/createDetailedEntities/createDetailedEntities';
import EditDetailedEntities from './components/editDetailedEntities/editDetailedEntities';
import Map from './components/Mapa/mapa';
import IdeationPlatform from './components/ideationPlatform/ideationPlatform';
import CreateSpeedmeeting from './components/createSpeedmeeting/createSpeedmeeting';
import ViewSpeedmeeting from './components/viewSpeedmeeting/viewSpeedmeeting';
import ViewUserSpeedmeeting from './components/viewUserSpeedmeeting/viewUserSpeedmeeting';
import ListOfSpeedmeeting from './components/listOfSpeedmeeting/listspeedmeeting';
import ViewCalendar from './components/viewCalendar/viewCalendar'
import Events from './components/Events/events'
import Advices from './components/Advices/advices'
import CreateAdvices from './components/createAdvices/createAdvices'
import CreateIdea from './components/createIdea/createIdea'
import SharedIdea from './components/sharedIdea/sharedIdea'
import ListIdea from './components/listIdea/listIdea'
import SearchResultsPage from './components/SearchResultsPage/SearchResultsPage'
import RegisterExternal from './components/RegisterExternal/RegisterExternal'
import DetailedEquipment from './components/DetailedEquipments/detailedequipments'
import Admin from './components/Admin/admin'
import NewsManagement from './components/NewsManagement/NewsManagement';
import ComingSoonPage from './components/ComingSoon/ComingSoon';
import PasswordRecovery from './components/PasswordRecovery/PasswordRecovery';
import PasswordRecoveryCode from './components/PasswordRecoveryCode/PasswordRecoveryCode';
import PasswordReset from './components/PasswordReset/PasswordReset';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import LandingPage from './components/LandingPage/LandingPage';
import ImportCSV from './components/ImportCSV/ImportCSV';
import ConfirmEmail from './components/ConfirmEmail/ConfirmEmail';
import PartnerLogin from './components/PartnerLogin/PartnerLogin';

function App() {
  return (
    <Router>
      <Routes>
        {/* Rotas públicas - APENAS autenticação */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/registerexternal" element={<RegisterExternal/>} />
        <Route path="/password-recovery" element={<PasswordRecovery />} />
        <Route path="/password-recovery-code" element={<PasswordRecoveryCode />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/comingsoon" element={<ComingSoonPage />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/partner-login"element={<PartnerLogin />}/>
 
        {/* Rotas protegidas - TODAS as outras rotas */}
        <Route path="/orientedSearch" element={<ProtectedRoute><OrientedSearch /></ProtectedRoute>} />
        <Route path="/entities" element={<ProtectedRoute><Entities /></ProtectedRoute>} />
        
        <Route path="/detailedentities/:id" element={<ProtectedRoute><DetailedEntities /></ProtectedRoute>} />
        <Route path="/createentity" element={<ProtectedRoute><CreateEntity /></ProtectedRoute>} />
        <Route path="/usersettings" element={<ProtectedRoute><UserSettings /></ProtectedRoute>} />
        <Route path="/listentities" element={<ProtectedRoute><ListOfEntities /></ProtectedRoute>} />
        <Route path="/createDetailedEntities" element={<ProtectedRoute><CreateDetailedEntities /></ProtectedRoute>} />
        <Route path="/editDetailedEntities" element={<ProtectedRoute><EditDetailedEntities /></ProtectedRoute>} />
        <Route path="/ideationPlatform" element={<ProtectedRoute><IdeationPlatform /></ProtectedRoute>} />
        <Route path="/createSpeedmeeting" element={<ProtectedRoute><CreateSpeedmeeting /></ProtectedRoute>} />
        <Route path="/viewSpeedmeeting" element={<ProtectedRoute><ViewSpeedmeeting /></ProtectedRoute>} />
        <Route path="/listspeedmeeting" element={<ProtectedRoute><ListOfSpeedmeeting /></ProtectedRoute>} />
        <Route path="/viewcalendar" element={<ProtectedRoute><ViewCalendar /></ProtectedRoute>} />
        <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
        <Route path="/advices" element={<ProtectedRoute><Advices /></ProtectedRoute>} />
        <Route path="/createAdvices" element={<ProtectedRoute><CreateAdvices /></ProtectedRoute>} />
        <Route path="/createIdea" element={<ProtectedRoute><CreateIdea /></ProtectedRoute>} />
        <Route path="/sharedIdea" element={<ProtectedRoute><SharedIdea /></ProtectedRoute>} />
        <Route path="/listIdea" element={<ProtectedRoute><ListIdea /></ProtectedRoute>} />
        <Route path="/viewUserSpeedmeeting" element={<ProtectedRoute><ViewUserSpeedmeeting /></ProtectedRoute>} />
        <Route path="/searchResults" element={<ProtectedRoute><SearchResultsPage /></ProtectedRoute>} />
        <Route path="/detailedEquipment/:id" element={<ProtectedRoute><DetailedEquipment /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
        <Route path="/mapa" element={<ProtectedRoute><Map /></ProtectedRoute>} />
        <Route path="/import-csv" element={<ProtectedRoute><ImportCSV /> </ProtectedRoute>} />
        <Route path="/newsmanagement" element={<ProtectedRoute><NewsManagement isManager={true} /></ProtectedRoute>} />
        
      </Routes>
    </Router>
  );
}

export default App;